import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Sıfırlama bağlantısı gönderildi");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50 dark:bg-slate-950">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-2xl font-bold font-display">Şifre sıfırlama</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">E-posta adresinize sıfırlama bağlantısı gönderelim</p>
        {sent ? (
          <div className="text-center py-6">
            <MailCheck className="h-12 w-12 text-emerald-500 mx-auto mb-3" />
            <p className="text-sm">Eğer bu e-posta kayıtlıysa, sıfırlama bağlantısı gönderildi. (Geliştirme modunda bağlantı sunucu günlüğüne yazılır.)</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>E-posta</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" className="mt-1.5" /></div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Bağlantı Gönder
            </Button>
          </form>
        )}
        <p className="text-sm text-center mt-4">
          <Link to="/login" className="text-primary hover:underline">Girişe dön</Link>
        </p>
      </Card>
    </div>
  );
}
